/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/display-name */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
  useContext,
} from "react";
import {
  Combobox,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import { isArrivalBeforeGeneration, showToast } from "utils/helper";
import {
  useGetCustomerServicePoints,
  useGetPendingReasons,
} from "utils/apis/lookups.api";
import { useUpdateKioskStatus } from "utils/apis/kiosk.api";
import { LookUpContext } from "utils/reducers/lookup";
import { formatDate } from "date-fns";
import type { CoinsDenom } from "utils/types/lookup.type";

import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import PartialDeliveryInfo from "components/partialDeliveryInfo";
import ContainersGrid from "components/containersGrid";
import AddContainers from "components/addContainers";

const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
const alphaNum = new RegExp(/^[A-Za-z0-9\s]+$/);
const alpha = new RegExp(/^[A-Za-z\s]+$/);
const mobileRegex = new RegExp(/^[0-9]{10}$/);
const numRegex = new RegExp(/^[0-9\s]+$/);

const KioskServiceUpdateCard = forwardRef(
  ({ request, statusList, statusUpdated }: any, ref) => {
    const currentDate = new Date();
    const { coinContainers } = useContext(LookUpContext);

    const [ddlStatus, setDdlStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [ddlReasons, setDdlReasons] = useState("");
    const [remarks, setRemarks] = useState<any>("");
    const [txtRemarksColor, setTxtRemarksColor] = useState("");

    const [servicePointId, setServicePointId] = useState("");
    const [vhrNo, setVhrNo] = useState("");
    const [vhrNoColor, setVhrNoColor] = useState("");
    const [locationArrivalTime, setLocationArrivalTime] = useState(currentDate);
    const [generateDateTime, setGenerateDateTime] = useState(currentDate);

    const [repEmployeeId, setRepEmployeeId] = useState("");
    const [txtEmpIdColor, setTxtEmpIdColor] = useState("");
    const [repName, setRepName] = useState("");
    const [txtSRNameColor, setTxtSRNameColor] = useState("");
    const [repEmail, setRepEmail] = useState("");
    const [txtEmailColor, setTxtEmailColor] = useState("");
    const [repMobileNo, setRepMobileNo] = useState("");
    const [txtMobileNoColor, setTxtMobileNoColor] = useState("");

    const [containers, setContainers] = useState<any[]>([]);
    const [packedContainers, setPackedContainers] = useState([]);

    const containersList = useRef<any>([]);

    const { data: reasons } = useGetPendingReasons();
    const { data: sourceLocations } = useGetCustomerServicePoints(
      request?.customerId,
    );

    const onDddStatusChanged = (value: string) => {
      if (!value) {
        setDdlStatus("");
        setSelectedStatus("");
      } else {
        setDdlStatus(value);
        setSelectedStatus(value);
      }
    };

    const onDdlReasonsChanged = (value: string) => {
      setDdlReasons(value);
    };

    const { mutate: updateStatus, isSuccess: statusSuccess } =
      useUpdateKioskStatus();

    const validVhrNo = (e: any) => {
      const vhrNo = e.target.value;
      if (!alphaNum.test(vhrNo)) {
        setVhrNoColor("bg-red-500/30 border-red-500");
        return;
      }
      setVhrNoColor("text-success");
    };

    const validateEmployeeId = (e: any) => {
      const employeeId = e.target.value;
      if (!numRegex.test(employeeId)) {
        setTxtEmpIdColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtEmpIdColor("text-success");
    };

    const validateEmail = (e: any) => {
      const email = e.target.value;
      if (!emailRegex.test(email)) {
        setTxtEmailColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtEmailColor("text-success");
    };

    const validateMobile = (e: any) => {
      const mobileNo = e.target.value;
      if (!mobileRegex.test(mobileNo)) {
        setTxtMobileNoColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtMobileNoColor("text-success");
    };

    const validateSRName = (e: any) => {
      const name = e.target.value;
      if (!alpha.test(name)) {
        setTxtSRNameColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtSRNameColor("text-success");
    };

    const onUpdatedData = (data: any) => {
      setPackedContainers(data);
    };
    const deleteContainer = (rowIndex: any) => {
      let updatedContainers: any;

      containers.map((row: any, index) => {
        if (index === rowIndex) {
          updatedContainers = containers.filter(
            (cc: any) => cc.deleteId !== row.deleteId,
          );
        }
        return row;
      });

      setContainers(updatedContainers);
      containersList.current = updatedContainers;
    };

    useImperativeHandle(ref, () => ({
      onBtnConfirmClicked(e: Event) {
        e.stopPropagation();

        if (!ddlStatus) {
          showToast("error", "Please select new status.");
          return;
        }

        const selectedStatus = ddlStatus;

        if (selectedStatus === "Pending" && !ddlReasons) {
          showToast("error", "Please select pending reason.");
          return;
        }

        if (selectedStatus === "Completed") {
          if (request?.isPrepack && !servicePointId) {
            return showToast("error", "Location is required.");
          }

          if (!vhrNo) {
            return showToast("error", "VHR No. is required.");
          }
          if (new Date() < new Date(generateDateTime)) {
            showToast(
              "error",
              "'Print Date & Time' should not be greater then current time.",
            );
            return;
          }

          if (
            !isArrivalBeforeGeneration(locationArrivalTime, generateDateTime)
          ) {
            showToast(
              "error",
              "Arrival Time should be less then 'Print Date & Time'",
            );
            return;
          }

          if (!packedContainers.length) {
            showToast("error", "There is no container to deliver.");
            return;
          }
        }

        let pendingReason = "";

        if (selectedStatus === "Pending") pendingReason = ddlReasons;

        if (
          selectedStatus === "Pending" &&
          pendingReason === "Other" &&
          remarks === ""
        ) {
          showToast("error", "Remarks are required for Other pending reason.");
          setTxtRemarksColor("text-error");
          return;
        }

        setTxtRemarksColor("");
        const siteRepresentatives = [
          {
            name: repName,
            employeeId: repEmployeeId,
            mobileNo: repMobileNo,
            email: repEmail,
          },
        ];

        const selectedContainers =
          selectedStatus === "Completed"
            ? packedContainers
                ?.filter((item: any) => item.status === "Delivered")
                .map((i: any) => ({
                  ...i,
                  declaredValue:
                    i.consignmentType === "Coins"
                      ? ((coinContainers as CoinsDenom[])?.find(
                          (row) =>
                            i.details === row.denomination &&
                            i.containerType === row.containerType,
                        )?.valuePerContainer || 0) * i.count
                      : i.declaredValue,
                  count:
                    i.consignmentType === "Coins"
                      ? i.count - i.returnedCount
                      : i.count,
                  returnedCount: 0,
                }))
            : containers;

        const updateDto = {
          requestId: request?.requestId,
          status: selectedStatus,
          pendingReason,
          remarks,
          ...(request?.isPrepack ? { servicePointId } : {}),

          vhr: {
            locationArrivalTime: formatDate(
              locationArrivalTime || currentDate,
              "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
            ),
            generateDateTime: formatDate(
              generateDateTime || currentDate,
              "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
            ),
            containers:
              (selectedContainers.length > 0
                ? [...selectedContainers, ...containers]
                : request?.containers) || [],
            siteRepresentatives,
          },
          packedContainers,
        };

        updateStatus(updateDto);
      },
    }));

    useEffect(() => {
      if (statusSuccess) {
        statusUpdated(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusSuccess]);

    useEffect(() => {
      if (
        request?.status === "Out for Delivery" &&
        request?.containers.length > 0
      ) {
        setPackedContainers(
          request?.containers?.map((i: any) => ({
            ...i,
            status: "Delivered",
          })),
        );
      }

      if (request) {
        setServicePointId(request?.servicePointId || "");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request?.containers]);
    return (
      <div className="flex gap-3 mt-5 w-full">
        <div className="flex-1">
          <h3 className="text-md font-bold">Select New Status</h3>
          <Select onValueChange={onDddStatusChanged} value={ddlStatus}>
            <SelectTrigger className="w-full my-3">
              <SelectValue placeholder="Select Status" />
            </SelectTrigger>
            <SelectContent>
              {statusList.map((item: any) => (
                <SelectItem key={item?.id} value={item?.id}>
                  {item?.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          {selectedStatus === "Pending" && (
            <>
              <div className="border-b my-3 bg-accent" />
              <label className="text-sm font-medium leading-none">
                Pending Reasons
              </label>
              <Combobox
                value={ddlReasons}
                data={reasons?.map((item) => ({
                  label: item.description,
                  value: item.description,
                }))}
                placeholder="Select Pending Reason"
                setValue={onDdlReasonsChanged}
              />
            </>
          )}
          {selectedStatus === "Completed" && (
            <>
              {request?.isPrepack ? (
                <div className="max-w-80 w-full">
                  <label className="text-sm font-medium leading-none">
                    Location
                  </label>
                  <Combobox
                    value={servicePointId}
                    data={sourceLocations?.map((item: any) => ({
                      label: `${item.barcode}-${item.locationId}`,
                      value: item.servicePointId,
                    }))}
                    placeholder="Select Location"
                    setValue={setServicePointId}
                  />
                </div>
              ) : null}
              <div className="border-b my-3 bg-accent" />
              <div className="flex mt-2 gap-2">
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    VHR No
                  </label>
                  <Input
                    placeholder="E-VHR No"
                    className={`w-full h-10  ${vhrNoColor}`}
                    value={vhrNo}
                    onChange={(e) => {
                      setVhrNo(e.target.value);
                    }}
                    onBlur={validVhrNo}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Location Arrival Time
                  </label>
                  <DateTimePicker
                    className="w-full h-10"
                    value={locationArrivalTime}
                    onChange={(e) => {
                      setLocationArrivalTime(e.target.value as any);
                    }}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Print Date & Time
                  </label>
                  <DateTimePicker
                    className="w-full h-10"
                    value={generateDateTime}
                    onChange={(e) => {
                      setGenerateDateTime(e.target.value as any);
                    }}
                  />
                </div>
              </div>

              <div className="border-b my-3 bg-accent" />
              <label className="text-sm font-medium leading-none">
                Site Representatives
              </label>
              <div className="border-b my-3 bg-accent" />
              <div className="flex gap-2 ">
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Name
                  </label>
                  <Input
                    placeholder="Name"
                    className={`w-full h-10  ${txtSRNameColor}`}
                    value={repName}
                    onChange={(e) => {
                      setRepName(e.target.value);
                    }}
                    onBlur={validateSRName}
                  />
                </div>
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Employee ID
                  </label>
                  <Input
                    placeholder="Employee Id"
                    className={`w-full h-10 ${txtEmpIdColor}`}
                    value={repEmployeeId}
                    onChange={(e) => {
                      setRepEmployeeId(e.target.value);
                    }}
                    onBlur={validateEmployeeId}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Mobile No
                  </label>
                  <Input
                    placeholder="Mobile No"
                    className={`w-full h-10 ${txtMobileNoColor}`}
                    value={repMobileNo}
                    onChange={(e) => {
                      setRepMobileNo(e.target.value);
                    }}
                    onBlur={validateMobile}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Email
                  </label>
                  <Input
                    placeholder="Email"
                    className={`w-full h-10 ${txtEmailColor}`}
                    value={repEmail}
                    onChange={(e) => {
                      setRepEmail(e.target.value);
                    }}
                    onBlur={validateEmail}
                  />
                </div>
              </div>
              <div className="border-b my-3 bg-accent" />
              <label className="text-sm font-medium leading-none">
                Containers
              </label>
              <div className="border-b my-3 bg-accent" />

              <AddContainers
                type="Kiosk Service"
                consignments={containers}
                setConsignments={setContainers}
              />
            </>
          )}
        </div>
        <div className="flex-1">
          <h3 className="text-md font-bold">Review</h3>
          {selectedStatus === "Completed" &&
            request?.containers?.length > 0 && (
              <PartialDeliveryInfo
                containers={packedContainers}
                onUpdatedData={onUpdatedData}
              />
            )}
          {containers.length > 0 && (
            <>
              <label className="text-sm font-medium leading-none mt-3 mb-2 block">
                Collected Containers
              </label>
              <ContainersGrid data={containers} removeRow={deleteContainer} />
            </>
          )}
          <div className=" mt-3">
            <label className="text-sm font-medium leading-none mb-2 block">
              Remarks
            </label>
            <Textarea
              placeholder="Enter remarks"
              className={`w-full  ${txtRemarksColor}`}
              rows={3}
              value={remarks}
              onChange={(e) => {
                setRemarks(e.target.value);
              }}
              onBlur={(e) => {
                if (e.target.value) {
                  setTxtRemarksColor("");
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  },
);

export default KioskServiceUpdateCard;
